export default __webpack_public_path__ + "static/media/LinkedInWhite.3e3c2b3a.svg";